import { Bugsnag } from "@bugsnag/browser";
import { BugsnagSeverity } from "ts/util/constant/BugsnagConst";
// import { ConsoleUtility } from "typescript-util-atlas/util";

/** Bugsnagクライアント */
declare const BUGSNAG_CLIENT: Bugsnag.Client | null | undefined;

/** Bugsnagユーティリティ */
export class BugsnagUtil {
  /** コンストラクタ封印 */
  private constructor() {}

  /**
   * Bugsnag へ送信する (INFOレベル)
   * @param e エラー情報
   * @param additionalTMetadata 追加タブ
   */
  static info(e: any, ...additionalTMetadata: Array<BugsnagMetadata>): void {
    BugsnagUtil.notify(BugsnagSeverity.INFO, e, ...additionalTMetadata);
  }

  /**
   * Bugsnag へ送信する (WARNレベル)
   * @param e エラー情報
   * @param additionalTMetadata 追加タブ
   */
  static warn(e: any, ...additionalTMetadata: Array<BugsnagMetadata>): void {
    BugsnagUtil.notify(BugsnagSeverity.WARNING, e, ...additionalTMetadata);
  }

  /**
   * Bugsnag へ送信する (ERRORレベル)
   * @param e エラー情報
   * @param additionalTMetadata 追加タブ
   */
  static error(e: any, ...additionalTMetadata: Array<BugsnagMetadata>): void {
    BugsnagUtil.notify(BugsnagSeverity.ERROR, e, ...additionalTMetadata);
  }

  /**
   * Bagsnag へ送信する
   * @param e エラー情報
   * @param severity エラーレベル
   * @param additionalTMetadata 追加タブ
   */
  private static notify(severity: BugsnagSeverity, e: any, ...additionalTMetadata: Array<BugsnagMetadata>): void {
    // ConsoleUtility.info(`[SEND BUGSNAG ${severity}]`, e);
    if (BUGSNAG_CLIENT == null) {
      // ConsoleUtility.info(`BUGSNAG_CLIENT IS null OR undefined`);
    } else {
      BUGSNAG_CLIENT?.notify(e, {
        beforeSend: report => {
          additionalTMetadata.forEach(metadata => {
            report.updateMetaData(metadata.section, metadata.value);
          });
        },
        severity
      });
    }
  }
}
